import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CancellationChargeModel, ConfigSettingsModel, LanguageDropdownModel } from '../../components/configuration/shared/configuration.model';
import { ServicetypeModel } from '../../components/coupon/shared/coupon.model';
import { PaymentModeModel } from '../../components/order/shipment-list/shared/shipment-list.model';
import { ReferralConfigurationModel, SelectedDataModel } from '../../components/referral-configuration/shared/referral-configuraion.model';
import { LocalStorageService } from '../../core/local-storage.service';
import { LanguageModel } from '../../views/login/login.model';
import { UserRole } from '../enum/base.enum';

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  constructor(private http: HttpClient, private localStorageService: LocalStorageService) { }

  getLanguages(): Observable<Array<LanguageModel>> {
    const url = environment.master_url + 'config/language';
    return this.http.get(url).pipe(map((response: Array<LanguageModel>) => {
      return response;
    }));
  }

  getLanguageData(obj): Observable<any> {
    const url = environment.master_url + 'langLabel/get/' + obj.language + '/' + obj.interface;
    return this.http.get(url).pipe(map((response: Array<any>) => {
      return response;
    }));
  }
  getLanguageDropdown(): Observable<LanguageDropdownModel[]> {
    const url = environment.master_url + 'language/language-list';
    return this.http.get(url).pipe(map((response: LanguageDropdownModel[]) => {
      return response;
    }));
  }
  getServiceTypeList(): Observable<ServicetypeModel[]> {
    const url = environment.master_url + 'service/type/getDDO'
    return this.http.get(url).pipe(map((response: ServicetypeModel[]) => {
      return response;
    }));
  }

  getAllConfigSettings(obj): Observable<ConfigSettingsModel[]> {
    const url = environment.master_url + 'config/setting/';
    return this.http.get(url + obj.countryUId + '/' + obj.shipmentTypeId).pipe(map((response: ConfigSettingsModel[]) => {
      return response;
    }));
  }

  getCancellationCharges(uId): Observable<CancellationChargeModel[]> {
    // tslint:disable-next-line:max-line-length
    const url = environment.master_url + 'service/cancellation/charge?countryUId=' + uId;
    return this.http.get(url).pipe(map((response: CancellationChargeModel[]) => {
      response.forEach(res => {
        res.orderStatusCDName = this.localStorageService.getSelectedLanguageValue('General.' + res.orderStatusCode)
      })
      return response;
    }));
  }

  getPaymentModes(application, value): Observable<PaymentModeModel[]> {
    const url = environment.master_url + 'language/payment-modes?appUId=' + application + '&serviceTypeId=' + value;
    return this.http.get(url).pipe(map((response: PaymentModeModel[]) => {
      response.unshift({
        code: 0,
        paymentType: '',
        logoUrl: '',
        name: this.localStorageService.getSelectedLanguageValue('General.All'),
        label: '',
        value: ''
      })
      response.filter(result => {
        result.label = result.name;
        result.value = result.paymentType;
      })
      return response;
    }));
  }

  saveConfigSetting(data): Observable<ConfigSettingsModel> {
    const url = environment.master_url + 'config/setting'+ '/' + data.shipmentTypeId;
    return this.http.put(url, data).pipe(map((response: ConfigSettingsModel) => {
      return response;
    }));
  }


  getBannerImageColumns() {
    return [
      { field: 'imageTitle', header: this.localStorageService.getSelectedLanguageValue('General.ImageTitle'), isShow: true, width: '10vh' },
      { field: 'contentKey', header: this.localStorageService.getSelectedLanguageValue('General.ContentKey'), class: 'fa fa-edit', isShow: true, width: '10vh' },
      { field: 'contentType', header: this.localStorageService.getSelectedLanguageValue('General.ContentType'), class: 'fa fa-edit', isShow: true, width: '10vh' },
      { field: 'effectiveDate', header: this.localStorageService.getSelectedLanguageValue('General.EffectiveDate'), isShow: true, width: '5vh' },
      { field: 'expiryDate', header: this.localStorageService.getSelectedLanguageValue('General.ExpiryDate'), isShow: true, width: '5vh' },
      { field: 'action', header: this.localStorageService.getSelectedLanguageValue('General.Action'), class: 'fa fa-eye', class1: 'fa fa-edit', isShow: false, width: '2vh' },
    ];
  }
  getBannerImageList(languageCD, mobileApp, webApp) {
    const url = environment.master_url + 'banner/image?LanguageCD=' + languageCD + '&MobileBanner=' + mobileApp + '&DesktopBanner=' + webApp;
    return this.http.get(url).pipe(map((response: any[]) => {
      return response;
    }));
  }
  getBanners() {
    const url = environment.master_url + 'banner/ddo';
    return this.http.get(url).pipe(map((response: any[]) => {
      return response;
    }));
  }
  getBannerImage(uId) {
    const url = environment.master_url + 'banner/image/' + uId;
    return this.http.get(url).pipe(map((response: any[]) => {
      return response;
    }));
  }
  saveBannerImage(uId, formData) {
    if (!uId) {
      const url = environment.master_url + 'banner/image/';
      return this.http.post(url, formData).pipe(map((response: any[]) => {
        return response;
      }));
    } else {
      const url = environment.master_url + 'banner/image/';
      return this.http.put(url, formData).pipe(map((response: any[]) => {
        return response;
      }));
    }
  }
  getDeletedUserColumns() {
    return [
      { field: 'name', header: this.localStorageService.getSelectedLanguageValue('General.Name'), isShow: true, width: '5vh' },
      { field: 'countryName', header: this.localStorageService.getSelectedLanguageValue('General.CountryName'), isShow: true, width: '5vh' },
      { field: 'stateName', header: this.localStorageService.getSelectedLanguageValue('General.StateName'), isShow: true, width: '5vh' },
      { field: 'cityName', header: this.localStorageService.getSelectedLanguageValue('General.CityName'), isShow: true, width: '5vh' },
      { field: 'deletionReason', header: this.localStorageService.getSelectedLanguageValue('General.Reason'), isShow: true, width: '8vh' },
      { field: 'deletionSubReason', header: this.localStorageService.getSelectedLanguageValue('General.SubReason'), isShow: true, width: '8vh' },
      { field: 'createdDateTime', header: this.localStorageService.getSelectedLanguageValue('General.Date'), isShow: true, width: '5vh' }
    ];
  }
  getDeletedUserList(params) {
    const url = environment.master_url + 'delete/account';
    return this.http.get(url, { params: params }).pipe(map((response: any) => {
      return response;
    }));
  }

  getRoles() {
    return [
      { label: 'Customer', value: UserRole.Customer },
      { label: 'Delivery Partner', value: UserRole.Driver },
    ]
  }

  getReferralConfiguration(searchData: SelectedDataModel): Observable<ReferralConfigurationModel>{
    const url = environment.master_url + 'referralConfiguration/' + searchData.selectedCity + '/' + searchData.selectedRole + '/' + searchData.selectedService;
    return this.http.get(url).pipe(map((response: ReferralConfigurationModel) => {
      return response;
    }));
  }

  addReferralConfiguration(data: ReferralConfigurationModel): Observable<any>{
    const url = environment.master_url + 'referralConfiguration';
    return this.http.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }

  updateReferralConfiguration(data: ReferralConfigurationModel): Observable<any>{
    const url = environment.master_url + 'referralConfiguration';
    return this.http.put(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
}
